import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { BlogApiData } from "../index";

interface FAQSectionProps {
  formData: BlogApiData;
  onSectionChange: (section: keyof BlogApiData["al_sections"], field: string, value: string) => void;
  onArrayItemChange: (section: keyof BlogApiData["al_sections"], arrayField: string, index: number, field: string, value: string) => void;
  quillModules: any;
  quillFormats: string[];
}

const FAQSection: React.FC<FAQSectionProps> = ({
  formData,
  onSectionChange,
  onArrayItemChange,
  quillModules,
  quillFormats,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Section Title
          </label>
          <input
            type="text"
            value={formData.al_sections.faqSection.title}
            onChange={(e) =>
              onSectionChange(
                "faqSection",
                "title",
                e.target.value
              )
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="e.g., Frequently Asked Questions"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Section Description
          </label>
          <ReactQuill
            theme="snow"
            value={formData.al_sections.faqSection.description}
            onChange={(value) =>
              onSectionChange(
                "faqSection",
                "description",
                value
              )
            }
            modules={quillModules}
            formats={quillFormats}
            placeholder="e.g., Common questions about exploring Tirana"
          />
        </div>
      </div>
      <div className="space-y-3">
        <h4 className="text-md font-medium text-gray-700">
          FAQ Items
        </h4>
        {formData.al_sections.faqSection.items.map(
          (
            faq: { question: string; answer: string },
            index: number
          ) => (
            <div
              key={index}
              className="space-y-3 p-3 border border-gray-200 rounded-md">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Question {index + 1}
                </label>
                <input
                  type="text"
                  value={faq.question}
                  onChange={(e) =>
                    onArrayItemChange(
                      "faqSection",
                      "items",
                      index,
                      "question",
                      e.target.value
                    )
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder={`e.g., What's the best time to visit Tirana?`}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Answer {index + 1}
                </label>
                <ReactQuill
                  theme="snow"
                  value={faq.answer}
                  onChange={(value) =>
                    onArrayItemChange(
                      "faqSection",
                      "items",
                      index,
                      "answer",
                      value
                    )
                  }
                  modules={quillModules}
                  formats={quillFormats}
                  placeholder={`e.g., Spring (April-June) and fall (September-October) offer pleasant weather...`}
                />
              </div>
            </div>
          )
        )}
      </div>
    </>
  );
};

export default FAQSection;
